module.exports = __webpack_public_path__ + "static/img/1.b331bf3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/sp/1.png
// module id = 0kTq
// module chunks = 0